<div class="sidebar">
    <div class="container">
        <!-- <div class="row mb-4">
            <div class="col align-self-center">
                <h6>{{'menu.main_navigation' | translate}}</h6>
            </div>
            <div class="col-auto">
                <a class="" data-bs-toggle="collapse" data-bs-target="#usersidebarprofile" aria-expanded="false" role="button" aria-controls="usersidebarprofile">
                    <i class="bi bi-person-circle"></i>
                </a>
            </div>
        </div>


        <div *ngIf="user" routerLink="/pages/profile/professional" class="row text-center collapse " id="usersidebarprofile">
            <div class="col-12">
                <div class="avatar avatar-100 rounded-circle shadow-sm mb-3 bg-white">
                    <figure class="avatar avatar-90 rounded-circle coverimg">
                        <img [src]="user.profileImgUrl" alt="" id="userphotoonboarding" name="userimage">
                    </figure>
                </div>
            </div>
            <div class="col-12 mb-4">
                <h6 class="mb-1" id="usernamedisplay">{{user.fullname}}</h6>
                <p class="text-secondary small">{{user.plant.name}}</p>
            </div>
        </div> -->

        <!-- user menu navigation -->
        <div class="row mb-4 d-none">
            <div class="col-12 px-0">
                <ul class="nav nav-pills">
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" routerLink="/pages/dashboard/home" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-house-door"></i></div>
                            <div class="col">{{'menu.home' | translate}}</div>
                            <div class="arrow"><i class="bi bi-chevron-right"></i></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <h6>{{'Configuration' | translate}}</h6>
        <div class="row mb-4">
            <div class="col-12 px-0">
                <ul class="nav nav-pills">
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/users'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-person"></i></div>
                            <div class="col">{{'users' | translate}}</div>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/plants'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-building"></i></div>
                            <div class="col">{{'plants' | translate}}</div>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/formulas'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-card-checklist"></i></div>
                            <div class="col">{{'formulas' | translate}}</div>
                        </a>
                    </li>
                </ul>
            </div>
        </div> -->

        <div class="row mb-4">
            <div class="col-12 px-0">
                <ul class="nav nav-pills">
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/forms/captures/pendings'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-journal-code"></i></div>
                            <div class="col">{{'forms' | translate}}</div>
                        </a>
                        <ul class="nav flex-column submenu">
                            <li class="nav-item">
                                <a class="nav-link sub-link" aria-current="page" [routerLink]="'/forms/reports'" routerLinkActive="active" (click)="menuclose()">
                                    <div class="avatar avatar-40 icon"><i class="bi bi-file-spreadsheet"></i></div>
                                    <div class="col">{{'reports' | translate}}</div>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <!-- se valida si tiene acceso al módulo, solo puse de ejemplo que tenga el modulo "documents" y que tenga permiso "view", pero también tener en cuenta que si es admin de este módulo debe poder entrar por ej -->
                    <!-- *ngIf="hasAccessToDocuments" -->
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/forms/sop'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-file-text"></i></div>
                            <div class="col">SOP Docs</div>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/forms/spec-sheets'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-file-earmark-text"></i></div>
                            <div class="col">Spec Sheets</div>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" aria-current="page" [routerLink]="'/forms/statistics'" routerLinkActive="active" (click)="menuclose()">
                            <div class="avatar avatar-40 icon"><i class="bi bi-clipboard2-data"></i></div>
                            <div class="col">{{'spc' | translate}}</div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
